import { Icon } from '@platform/ui';
import type { IPageIconProps } from './IPageIconProps';
import { LAW_MODEL_ICON } from './lawModelIcon';

/** Товщина лінії іконок сторінок модуля в прототипі v4 (svg stroke-width 1.9). */
const STROKE = 1.9;

/**
 * Іконка сторінки модуля: Lucide зі спрайта, а «Візуальна модель закону» — власний гліф прототипу v4 (три вузли, з'єднані від верхнього;
 * у Lucide такого немає). Декоративна (aria-hidden), колір — currentColor.
 */
export function PageIcon({ name, size, className }: IPageIconProps) {
  if (name !== LAW_MODEL_ICON) return <Icon name={name} size={size} strokeWidth={STROKE} className={className} />;
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={STROKE}
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="5" r="2.5" /><circle cx="5" cy="19" r="2.5" /><circle cx="19" cy="19" r="2.5" />
      <path d="M12 7.5v4M12 11.5l-5.5 5.5M12 11.5l5.5 5.5" />
    </svg>
  );
}
